import React from 'react';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { useLocation } from 'react-use';
import { Cont, Title, SelectBox, DammyTxt, Select } from './styles';
import { getLocalizedPath } from '@src/utils/language-route';

const LangSelecta = props => {
	const { pathname } = useLocation();
	const currentPath = pathname || "/";
	return (
		<Cont className={ props.className }>
			<Title>Language</Title>
			<SelectBox>
				<DammyTxt>{ props.lang == 'ja' ? 'Japanese':'English' }</DammyTxt>
				<Select onChange={ e => {
						navigate(getLocalizedPath(currentPath, e.target.value as "ja" | "en"));
					}}
				>
					<option
						value="ja"
						selected={ props.lang == 'ja' ? true : false }
						children="Japanese"
					/>
					<option
						value="en"
						selected={ props.lang == "en" ? true : false }
						children="English"
					/>
				</Select>
			</SelectBox>
		</Cont>
	);
}

const mapStateToProps = (state,props) => ({
	lang: state.langReducer.language,
})

export default connect(mapStateToProps)(LangSelecta);
